/* Lotsa Goodies / 2026: polished quick-add + instant cart feedback.
   Runs only on the unpublished-theme homepage. */
(function(){
  'use strict';
  if(window.__lgdPremiumInitialized)return;
  window.__lgdPremiumInitialized=true;
  var toast;
  var toastTimer;
  function setupToast(){
    if(toast)return toast;
    toast=document.createElement('div');
    toast.className='lgd-premium-toast';
    toast.hidden=true;toast.setAttribute('role','status');toast.setAttribute('aria-live','polite');toast.setAttribute('aria-atomic','true');
    var check=document.createElement('span');check.className='lgd-toast-check';check.textContent='✓';check.setAttribute('aria-hidden','true');
    var content=document.createElement('span');content.className='lgd-toast-content';
    var heading=document.createElement('strong');heading.className='lgd-toast-heading';heading.textContent='Added to your cart';
    var detail=document.createElement('span');detail.className='lgd-toast-detail';
    var link=document.createElement('a');link.href=((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/')+'cart';link.textContent='View cart →';
    content.append(heading,detail,link);
    var close=document.createElement('button');close.type='button';close.setAttribute('aria-label','Close cart notification');close.textContent='×';close.addEventListener('click',function(){toast.hidden=true;});
    toast.append(check,content,close);document.body.appendChild(toast);
    return toast;
  }
  function showToast(title,message,isError){
    var box=setupToast();
    var heading=box.querySelector('.lgd-toast-heading'), detail=box.querySelector('.lgd-toast-detail');
    heading.textContent=title;detail.textContent=message||'';
    box.style.borderLeftColor=isError?'#7c7c7c':'#d71931';
    var check=box.querySelector('.lgd-toast-check');check.textContent=isError?'!':'✓';check.style.background=isError?'#7c7c7c':'#d71931';
    box.hidden=false;
    clearTimeout(toastTimer);toastTimer=setTimeout(function(){box.hidden=true;},5500);
  }
  function shopRoot(){return(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';}
  function updateCount(cart){
    if(!cart||typeof cart.item_count!=='number')return;
    document.querySelectorAll('[data-cart-count]').forEach(function(node){
      node.textContent=cart.item_count>99?'99+':String(cart.item_count);
      var badge=node.closest('.cart-count-bubble');if(badge){badge.classList.add('lgd-cart-bump');setTimeout(function(){badge.classList.remove('lgd-cart-bump');},500);}
    });
    document.querySelectorAll('.cart-count-bubble .visually-hidden').forEach(function(node){node.textContent=String(cart.item_count)+' items in cart';});
    document.dispatchEvent(new CustomEvent('lgd:cart-updated',{detail:{cart:cart}}));
  }
  async function fetchCart(){
    var resp=await fetch(shopRoot()+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}});
    if(!resp.ok)throw Error('Unable to refresh cart');
    return resp.json();
  }
  async function onQuickAdd(event){
    var form=event.target.closest('form.lgd-buyform');
    if(!form||!form.closest('.lgd-hollar'))return;
    event.preventDefault();event.stopPropagation();
    var button=form.querySelector('button[type=submit]');
    if(!button||button.disabled)return;
    var id=form.querySelector('input[name=id]');
    if(!id||!id.value)return;
    var card=form.closest('.lgd-card'), title=card&&card.querySelector('.lgd-card-title');
    var productName=title?title.textContent.trim():'Goodie';
    var original=button.innerHTML;
    button.disabled=true;button.setAttribute('aria-busy','true');
    var label=button.querySelector('.lgd-button-label');if(label)label.textContent='Adding…';
    try{
      var resp=await fetch(shopRoot()+'cart/add.js',{
        method:'POST',body:new FormData(form),credentials:'same-origin',headers:{Accept:'application/json'}
      });
      var payload=await resp.json();
      if(!resp.ok)throw Error(payload.description||payload.message||'Could not add item');
      var cart=await fetchCart();
      updateCount(cart);
      button.classList.add('is-added');
      if(label)label.textContent='Added!';
      var icon=button.querySelector('.lgd-add-icon');if(icon)icon.textContent='✓';
      var qty=(cart.item_count===1?'1 item':cart.item_count+' items');
      showToast('Added to your cart',productName+' · '+qty);
      document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{cart:cart}}));
      document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cart}}));
    }catch(err){
      showToast('Could not add item',err&&err.message?err.message:'Please try again.',true);
    }finally{
      setTimeout(function(){button.innerHTML=original;button.classList.remove('is-added');button.disabled=false;button.removeAttribute('aria-busy');},1450);
    }
  }
  // One delegated listener also handles products appended by infinite scroll.
  document.addEventListener('submit',onQuickAdd,true);
})();